import React from "react";
import { forwardRefAs, Generic } from "../../base";
export const TableFoot = forwardRefAs((props, ref) => React.createElement(Generic, Object.assign({ ref: ref }, props)), { as: "tfoot" });
TableFoot.displayName = "Table.Foot";
//# sourceMappingURL=table-foot.js.map